import ic_upload_icon from "../../assets/images/ic_document_icon.png";
import pdf_icon from "../../assets/images/pdf_icon.png";
import png_icon from "../../assets/images/png_icon.png";
import jpg_icon from "../../assets/images/jpg_icon.png";
import jpeg_icon from "../../assets/images/jpeg_icon.png";
import { toast } from "react-toastify";
import {
  ButtonDiv,
  DivFile,
  DropzoneFiles,
  DropzoneFilesContainer,
  ImgFile2,
  LengthInfo,
  ImgFile,
  InputFile,
  PDFView,
} from "./style";
import {
  Box,
  Collapse,
  ListItemButton,
  ListItemText,
  Typography,
  List,
  Modal,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import axios from "axios";
import { URL_API } from "config";
import ImageView from "components/ImageView";
import MDButton from "components/MDButton";
import { useParams } from "react-router-dom";
import MDTypography from "components/MDTypography";

export default function DropzoneCooperatedFiles({
  onChange,
  label,
  files,
  setFiles,
  required = false,
}) {
  const { uuid } = useParams();

  const [key, setKey] = useState(null);
  const [trigger, setTrigger] = useState(false);
  const [src, setSrc] = useState();
  const [open, setOpen] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);

  useEffect(() => {
    if (src) setOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  const dropped = async (event) => {
    event?.preventDefault();

    const newFiles = [];

    if (event?.dataTransfer?.items && event?.dataTransfer?.items?.length > 0) {
      for (const item of event?.dataTransfer?.items) {
        newFiles.push(item?.getAsFile());
      }
    } else if (
      event?.dataTransfer?.files &&
      event?.dataTransfer?.files?.length > 0
    ) {
      for (const item of event?.dataTransfer?.files) {
        newFiles.push(item);
      }
    }
  };

  const remove = (file) => {
    setFiles((files) => {
      const newFiles = files;
      newFiles.splice(newFiles.indexOf(file), 1);
      return [...newFiles];
    });
  };

  const dragover = (event) => event?.preventDefault();

  const getCooperatedDocument = async (document_uuid) => {
    try {
      const res = await axios.get(
        URL_API + `/user-documents/${uuid}/document?file=${document_uuid}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Tag")}`,
          },
        }
      );

      return res.data;
    } catch (error) {
      return 500;
    }
  };

  const base64 = (document_uuid) => {
    getCooperatedDocument(document_uuid).then((res) => {
      if (res !== 500) {
        setSrc(filename(res.type, res.fileToBase64));
        setTrigger(!trigger);
      }
    });
  };

  const filename = (type, value) => {
    const png = "data:image/png;base64,";
    const jpg = "data:image/jpg;base64,";
    const jpeg = "data:image/jpeg;base64,";
    const pdf = "data:application/pdf;base64,";

    const fileToBase64 = `${
      type === "png" ? png : type === "jpeg" ? jpeg : type === "jpg" ? jpg : pdf
    }${value}`;

    return fileToBase64;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file.size <= 1048576) {
      return;
    } else {
      setFiles((files) => {
        files.splice(files.indexOf(file), 1);

        return [...files];
      });

      toast.info("Arquivo maior que 1 MB");
    }
  };

  return (
    <DropzoneFilesContainer>
      <DropzoneFiles
        className="dropzoneFiles"
        onDrop={dropped}
        onDragOver={dragover}
        onChange={handleFileChange}
      >
        {required && (
          <Typography variant="body2" color="secondary" marginTop={2}>
            Informação obrigatória <strong style={{ color: "red" }}>*</strong>
          </Typography>
        )}
        <InputFile
          type="file"
          accept=".png, .jpg, .jpeg, .pdf"
          onChange={onChange}
        />
        <ImgFile src={ic_upload_icon} />
        <MDTypography variant="caption">{label}</MDTypography>
      </DropzoneFiles>
      <List
        sx={{
          bgcolor: "#d2d3db",
          borderRadius: "0 0 8px 8px",
          marginBottom: "1rem",
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        <ListItemButton
          onClick={() => setSelectOpen(!selectOpen)}
          disabled={!files.length}
        >
          <ListItemText
            primary={
              <Box display="flex" justifyContent="flex-start">
                <Typography variant="h6">
                  {label.split("Adicionar ")[1]}
                </Typography>

                <LengthInfo disabled>{files.length}</LengthInfo>
              </Box>
            }
          />
          {selectOpen && files.length ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse
          in={selectOpen && files.length}
          timeout="auto"
          unmountOnExit
          sx={{
            bgcolor: "background.paper",
            borderBottom: "2px solid #d2d3db",
            borderLeft: "2px solid #d2d3db",
            borderRight: "2px solid #d2d3db",
            borderRadius: "0 0 8px 8px",
          }}
        >
          <List component="div" disablePadding>
            {files.map((file) => {
              return (
                <>
                  <ListItemButton sx={{ pl: 4 }}>
                    <DivFile key={file.localUrl} style={{ flex: 1 }}>
                      {(file?.name ?? file?.key)?.split(".").pop() === "pdf" ? (
                        <ImgFile2
                          alt="selected"
                          src={pdf_icon}
                          onClick={() => {
                            if (file.uuid) {
                              setKey(file.key);
                              base64(file.uuid);
                            }
                          }}
                        />
                      ) : (file?.name ?? file?.key)?.split(".").pop() ===
                        "png" ? (
                        <ImgFile2
                          alt="selected"
                          src={png_icon}
                          onClick={() => {
                            if (file.uuid) {
                              setKey(file.key);
                              base64(file.uuid);
                            }
                          }}
                        />
                      ) : (file?.name ?? file?.key)?.split(".").pop() ===
                        "jpg" ? (
                        <ImgFile2
                          alt="selected"
                          src={jpg_icon}
                          onClick={() => {
                            if (file.uuid) {
                              setKey(file.key);
                              base64(file.uuid);
                            }
                          }}
                        />
                      ) : (
                        <ImgFile2
                          alt="selected"
                          src={jpeg_icon}
                          onClick={() => {
                            if (file.uuid) {
                              setKey(file.key);
                              base64(file.uuid);
                            }
                          }}
                        />
                      )}
                      <p
                        style={{
                          cursor: "pointer",
                          fontFamily: "Roboto",
                          fontSize: "11pt",
                        }}
                      >
                        <span>{file?.name ?? file?.key}</span>
                      </p>
                      {file.uuid && (
                        <p
                          style={{
                            cursor: "pointer",
                            fontFamily: "Roboto",
                            marginLeft: "3pt",
                            fontSize: "12pt",
                          }}
                          onClick={() => {
                            if (file.uuid) {
                              setKey(file.key);
                              base64(file.uuid);
                            }
                          }}
                        >
                          <span>
                            <MDButton
                              variant="gradient"
                              color="light"
                              size="small"
                            >
                              Abrir Arquivo
                            </MDButton>
                          </span>
                        </p>
                      )}
                      <ButtonDiv
                        style={{ cursor: "pointer" }}
                        onClick={() => remove(file)}
                      >
                        x
                      </ButtonDiv>
                    </DivFile>
                    <br />
                  </ListItemButton>
                </>
              );
            })}
          </List>

          <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{
              overflow: "scroll",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            {key?.split(".").pop() === "pdf" ? (
              <PDFView src={src} alt="selected" />
            ) : (
              <ImageView
                preview={label.split("Adicionar ")[1].toUpperCase()}
                src={src}
                setOpen={() => setOpen(false)}
              />
            )}
          </Modal>
        </Collapse>
      </List>
    </DropzoneFilesContainer>
  );
}
